import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import { ShieldX } from 'lucide-react'

/**
 * 403 Forbidden 페이지
 *
 * 관리자 권한이 없는 사용자가 /admin에 접근할 때 표시
 */
export function Forbidden() {
  const { t } = useTranslation()

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4">
      <div className="absolute right-4 top-4">
        <LanguageSwitcher />
      </div>
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <ShieldX className="h-10 w-10 text-red-600" />
        </div>
        <h1 className="mb-2 text-3xl font-bold text-slate-900">{t('pages.forbiddenTitle')}</h1>
        <p className="mb-6 text-slate-600">
          {t('pages.forbiddenDescription')}
        </p>
        <Button asChild>
          <Link to="/">{t('pages.backToMain')}</Link>
        </Button>
      </div>
    </div>
  )
}
